import { Injectable, Signal, signal } from '@angular/core';

import type { Task } from '@gfe/features/components/visualization/timeline/models/timeline';

import { ConversationV4 } from '@core/models/comments-v4.model';

import { AnchoredPopupState } from '@shared/services/anchored-popup/anchored-popup-state';

/**
 * Singleton store for the timeline step popup. Only one popup is open at a time.
 * The conversation is fetched asynchronously after open(); the outlet reflects
 * `loading` until setConversation() arrives.
 */
@Injectable({ providedIn: 'root' })
export class TimelineStepPopupService extends AnchoredPopupState<Task> {
  private readonly _conversation = signal<ConversationV4 | null>(null);
  private readonly _loading = signal<boolean>(false);
  private readonly _saving = signal<boolean>(false);

  readonly conversation: Signal<ConversationV4 | null> = this._conversation.asReadonly();
  readonly loading: Signal<boolean> = this._loading.asReadonly();
  readonly saving: Signal<boolean> = this._saving.asReadonly();

  override open(anchorEl: HTMLElement, task: Task): void {
    super.open(anchorEl, task);
    this._conversation.set(null);
    this._loading.set(true);
    this._saving.set(false);
  }

  setConversation(conversation: ConversationV4 | null): void {
    if (!this.state()) return;
    this._conversation.set(conversation);
    this._loading.set(false);
  }

  setLoading(loading: boolean): void {
    if (!this.state()) return;
    this._loading.set(loading);
  }

  setSaving(saving: boolean): void {
    if (!this.state()) return;
    this._saving.set(saving);
  }
}
